import { TransparentButton, Typography } from '@libs/components';
import styled from 'styled-components';
export const CopyLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  width: 100%;
  justify-content: space-between;
`;
export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
type ActionButtonProps = {
  color?: string;
};
export const ActionButton = styled(TransparentButton)<ActionButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ color, theme }) =>
    color ?? theme.colors.surface.interactiveDefault};
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.8rem;
  &:last-child {
    margin: 0;
  }
`;
export const AssetInfoTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
